<template>
  <div>
    <nav-bar class="d-none d-sm-block " ref="form"/>
    <div class="primary-bg d-block d-sm-none">
      <router-link to="BlogPosts">
        <v-btn
            elevation="0"
            color="secondary"
            class="rounded-lg m-2"
            @click="overlay = !overlay"
        >
          <i class="fas fa-angle-left"></i>
          <span class="white--text pr-5 ">بازگشت</span>
        </v-btn>
      </router-link>
    </div>
    <div v-if="isPageLoaded" class="container py-16 mx-auto">
      <div class="row sec-garay-bg mx-10 mx-auto">
        <div class="col-12 col-lg-4 mx-auto ">
          <img class="d-none d-sm-block mx-auto" :src="$replaceHttps(BlogPostDetail.image)" width="400" height="400">
          <img class="d-block d-sm-none mx-auto" :src="$replaceHttps(BlogPostDetail.image)" width="300" height="300">
        </div>
        <div class="col-12 col-lg-6 px-5 mx-auto">
          <div> نام مقاله: {{ BlogPostDetail.title }}</div>
          <div v-html="BlogPostDetail.description"></div>
        </div>
      </div>
    </div>
    <footer-menu></footer-menu>
    <v-overlay
        id="searchOverLay"
        :absolute="false"
        :color="'#f7f1fc'"
        :opacity="0.7"
        :value="showLoaderDialog"
        :z-index="6">
      <div class="row h-100 align-items-center justify-content-center">
        <div class="loading-spinner">
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>

import FooterMenu from "@/components/footer";
import NavBar from "@/components/navBar";

export default {
  name: "BlogPosts-details",
  components: {NavBar, FooterMenu},
  metaInfo: {
    title: 'ماشین سازان اصلانیان-اخبار و مقالات'
  },
  data: () => ({
    isPageLoaded: false,
    BlogPostDetail: {},
    showLoaderDialog: false,
  }),
  mounted() {
    this.getData()
  },
  methods: {
    getImgUrl(pic) {
      return require("../assets/img/" + pic);
    },
    getData() {
      this.showLoaderDialog = true;
      let requestOptions = {
        method: 'GET',
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "Home/BlogPostDetail?ID=" + this.$route.query.BlogPostDetail, requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            console.log(json)
            this.BlogPostDetail = json
            this.showLoaderDialog = false;
            this.isPageLoaded = true
          })
          .catch(error => console.log('error', error));
    }
  }
}
</script>

<style scoped>

</style>